import axios from 'axios'
import { getCurrentToken, getTokenContent, isDefined } from './common'
import { loadCurrentTabCurrencyHeaderValue } from 'context/CurrencyFilter/currencyFilterStorage'
import { CURRENCY_FILTER_HEADER } from 'constants/headers'

const API_URL = process.env.REACT_APP_API_URL

const request = axios.create({
  baseURL: API_URL,
  timeout: 300000,
})

request.interceptors.request.use(
  (config) => {
    const token = getCurrentToken()
    config.headers = {
      'X-LOCALIZATION-LANG': navigator.language.split('-')[0],
      ...config.headers,
    }
    if (isDefined(token)) {
      const isIntegration = Boolean(config.headers.Authorization)
      config.headers['Authorization'] = isIntegration ? config.headers.Authorization : `Bearer ${token}`
      const tokenContent = getTokenContent(token)
      config.headers['factorId'] = tokenContent.factorId
      const currencyFilter = loadCurrentTabCurrencyHeaderValue(tokenContent.userId)
      const skipCurrencyFilter = (config as { skipCurrencyFilter?: boolean }).skipCurrencyFilter === true
      if (isDefined(currencyFilter) && !skipCurrencyFilter) {
        config.headers[CURRENCY_FILTER_HEADER] = currencyFilter
      }
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

request.interceptors.response.use(
  (response) => {
    return response
  },
  (error: any) => {
    return Promise.reject(error)
  }
)

export default request
